
import { mapState, mapActions, mapMutations } from 'vuex'
import TableCustomSort from '@/components/table-custom-sort/table-custom-sort'
import UploadBtn from '@/components/upload-btn/upload-btn.vue'
import DateRangeFormModal from '@/components/modals/date-range-form-modal/date-range-form-modal.vue'
import CourierDetailModal from '@/components/modals/courier-detail-modal/courier-detail-modal.vue'
import TextModal from '@/components/modals/text-modal/text-modal.vue'
import IcArrowLeft from '@/assets/svg/ic-arrow-left.svg?inline'
import IcArrowRight from '@/assets/svg/ic-arrow-right.svg?inline'
import IcEdit from '@/assets/svg/ic-edit.svg?inline'
import formatFunctons from '@/components/mixins/format-functions'

export default {
  name: 'Statistics',
  mixins: [formatFunctons],
  components: {
    TableCustomSort,
    UploadBtn,
    DateRangeFormModal,
    CourierDetailModal,
    TextModal,
    IcArrowLeft,
    IcArrowRight,
    IcEdit
  },
  data() {
    return {

      editCourierId: null,

      table: {
        columns: [
          {
            field: 'courier',
            thClass: 'courier-th',
            tdClass: 'courier-td',
            sortFn: this.courierSort
          },
          {
            field: 'platform',
            label: 'Платформа',
            tdClass: 'platform-td',
            sortFn: this.appSort,
          },
          {
            field: 'app_version',
            label: 'Приложение',
            tdClass: 'app-td',
            sortFn: this.appSort
          },
          {
            field: 'filter-left',
            thClass: 'filter-th',
            tdClass: 'filter-td',
            sortable: false
          },
          ...['day_0', 'day_1', 'day_2', 'day_3', 'day_4', 'day_5', 'day_6']
          .map(d => ({
            field: d,
            tdClass: 'time-td',
            sortable: false
          })),
          {
            field: 'filter-right',
            thClass: 'filter-th',
            tdClass: 'filter-td',
            sortable: false
          }
        ]
      },
      weekStartFilter: this.$moment().startOf('day').weekday(0),
      listCouriers: [],
      shiftToChange: null,
      shiftAction: 'create', // create | change,
      rewriteShiftsWarnings: [],
    }
  },
  computed: {
    ...mapState({
      user: state => state.users.user
    }),
    showedDates() {
      const res = [this.weekStartFilter]
      for (let i = 1; i <= 6; i++) {
        res.push(this.weekStartFilter.clone().weekday(i))
      }
      return res
    },
    
    getDateByField() {
      /**
       * 
       * @param {*} field - например day_0
       */
      return (field) => {
        const index = +field.split('_')[1]
        return this.showedDates[index]
      }
    },
    editModalTexts() {
      const fullName = this.shiftToChange ? `${this.shiftToChange.last_name} ${this.shiftToChange.first_name}` : ''
      switch (this.shiftAction) {
        case 'create':
          return {
            header: 'Создание смены',
            description: `Создать смену для курьера ${fullName ? `<div><b>${fullName}</b>?<div>` : '?'}`,
            startLabel: 'Начало смены',
            endLabel: 'Окончание смены',
            btnSubmit: 'Создать'
          }
        case 'change': 
          return {
            header: 'Изменить время смены',
            description: `Вы уверены, что хотите изменить время смены для курьера ${fullName ? `<div><b>${fullName}</b>?<div>` : '?'}`,
            startLabel: 'Начало смены',
            endLabel: 'Окончание смены',
            btnSubmit: 'Сохранить'
          }
      }
    },
  },
  mounted() {
    this.getSheduleFilter()
  },
  methods: {
    ...mapActions({
      setActionShift: 'couriers/setActionShift',
      createNewShift: 'couriers/createNewShift',
      uploadShiftsFile: 'couriers/uploadShiftsFile',
      getShedule: 'couriers/getShedule'
    }),
    ...mapMutations({
      setLoading: 'pageLoader/SET_LOADING'
    }),
    async getSheduleFilter() {
      this.setLoading(true)
      try {
        const res = await this.getShedule(this.weekStartFilter.clone().utc().format())
        this.listCouriers = [ ...res.working_couriers, ...res.rest_couriers ]
      } finally {
        this.setLoading(false)
      }      
    },
    /**
     * 
     * @param {*} name - пример: 0.0.1-debug (157)
     */
    getAppNameHtml(name) {
      if (name) {
        const strArr = name.split('(')
        if (strArr.length === 2) {
          return `<b>${strArr[0]}</b> (${strArr[1]}`
        }
        return name
      }
      return name
    },
    courierSort() {
      this.$refs.table.sorts = [{
        field: 'courier',
        type: 'none'
      }]
    },
    appSort(a, b, col, rowA, rowB) {
      const sortType = this.$refs.table.sorts.length ? this.$refs.table.sorts[0].type : 'asc'
      const sortAsc = sortType === 'asc' ? true : false;
      if (sortAsc && a === null) {
        return 1
      }
      if (sortAsc && b === null) {
          return -1
      }
      if (!sortAsc && a === null) {
          return -1
      }
      if (!sortAsc && b === null) {
          return 1
      }
      const aStr = a.toLowerCase()
      const bStr = b.toLowerCase()

      if (aStr === bStr) {
        const aName = `${rowA.last_name} ${rowA.first_name}`.toLowerCase()
        const bName = `${rowB.last_name} ${rowB.first_name}`.toLowerCase()
        return (aName < bName ? -1 : (aName > bName ? 1 : 0))
      }

      return (aStr < bStr ? -1 : (aStr > bStr ? 1 : 0))
    },
    async uploadShiftsFileUpdate(data) {
      const res = await this.uploadShiftsFile(data)
      if (res.already_opened_shifts.length) {
        this.rewriteShiftsWarnings = res.already_opened_shifts.map(item => {
          return `
            На время ${this.$moment(item.datetime_start).format('DD-MM-YYYY HH:mm:ss')} невозможно открыть смену.
            У курьера с id ${item.courier_dosta_id} уже была открыта смена в этот день.
          `
        })
      }
      if (res.missing_couriers_ids.length) {
        this.rewriteShiftsWarnings = [ ...this.rewriteShiftsWarnings,
          `В базе отсутствуют курьеры со следующими id: ${res.missing_couriers_ids.join(', ')}`
        ]
      }
      if (this.rewriteShiftsWarnings.length) {
        this.$nextTick(() => {
          this.$refs['rewrite-warning-modal'].show()
        })
      }
      await this.getSheduleFilter()
    },
    async setWeekStartFilter(isNext) {
      const numberWeekStart = isNext ? 7 : -7
      this.weekStartFilter = this.weekStartFilter.clone().weekday(numberWeekStart)
      await this.getSheduleFilter()
    },
    getShiftObject(shiftsArr, date) {
      /**
       * все смены (по ключам shifts) отсортированы по времени старта,
       * если на день несколько смен, выводить нужно последнюю
       */
      const shiftsArrReverse = [ ...shiftsArr ].reverse()
      return shiftsArrReverse.find(shift => {
        const dateFrom = this.$moment(shift.time_from)
        return dateFrom.startOf('day').diff(date.clone()) === 0
      })
    },
    onCellClick({ row, column }) {
      if (column.field === 'courier') {
        this.showCourierDetailInfo(row)
      }
    },
    
    async showCourierDetailInfo(shiftsRow) {
      this.editCourierId = shiftsRow.courier_id
      this.$nextTick(() => {
        this.$refs['courier-detail-modal'].show()
      })
    },
    openCreateEditModal(shift, action) {
      this.shiftAction = action
      if (this.shiftAction === 'create') {
        const nowTime = this.$moment()
        shift.time_from
          .hour(nowTime.hour())
          .minute(nowTime.minute())
          .second(nowTime.second())
          .millisecond(nowTime.millisecond())
      }
      this.shiftToChange = shift
      this.$nextTick(() => {
        this.$refs['date-range-form-modal'].show()
      })
    },
    async onChangeDateRange(event) {
      if (this.shiftAction === 'change') {
        await this.setActionShift({
          shift_id: this.shiftToChange.id,
          data: {
            action: 'modify_working_period',
            datetime_start: this.$moment(event.dateFrom).utc().format(),
            datetime_end: this.$moment(event.dateTo).utc().format()
          }
        })
      } else if (this.shiftAction === 'create') {
        await this.createNewShift({
          courier_id: this.shiftToChange.courier_id,
          datetime_start: this.$moment(event.dateFrom).utc().format(),
          datetime_end: this.$moment(event.dateTo).utc().format()
        })
      }
      this.shiftToChange = null
      this.$refs['date-range-form-modal'].hide()
      await this.getSheduleFilter()
    },
    onCourierChanged(event) {
      const findedCourier = this.listCouriers.find(c => c.courier_id === event.courier_id)
      if (findedCourier) {
        Object.assign(findedCourier, event)
      }
    },

    onCourierShiftChange() {
      this.getSheduleFilter()
    }
  }
}